import { z } from "zod";

import { dimensionsSchema } from "../packaging-solution/packaging-component/packaging-component-base";

export const contentSavedSchema = z.object({
	identifier: z.string(),
	quantity: z.number(),
	attributes: z.record(z.string(), z.string()),
	dimensions: dimensionsSchema,
	weight: z.number(),
});
